import { BaseEvent } from '@kiplin/web-common/event';

export type ClientGamesRefreshRequestedEventData = {
  clientId: string;
  gameId: string;
  gameKind: string;
  requestId: string;
};

export class ClientGamesRefreshRequestedEvent extends BaseEvent<ClientGamesRefreshRequestedEventData> {
  public static getKey(): string {
    return 'client-games-refresh-requested';
  }

  public constructor(init: CustomEventInit<ClientGamesRefreshRequestedEventData>) {
    super(ClientGamesRefreshRequestedEvent.getKey(), init);
  }
}
